import * as React from "react";
import { ContentPicker } from "../components/ContentPicker";
import { ContentViewModel, ListContent, ImageTypes, EntityTypes } from "../content/ContentStore";

const TournamentLogoPicker = ({ onSelect, disabled, uri }) => {
    const [options, setOptions] = React.useState([] as ContentViewModel[]);

    React.useEffect(() => {
        ListContent(ImageTypes.Logo, EntityTypes.Tournament, 0, 50).then((res) => {
            setOptions(res.result);
        });
    }, []);
    return (
        <ContentPicker
            label="Logo"
            onSelect={onSelect}
            uri={uri}
            width="150px"
            options={options}
            optionWidth="65px"
            optionHeight="65px"
            suggestedSize="512px x 512px"
            optionsPageSize={18}
            disabled={disabled}
        ></ContentPicker>
    );
};

export default TournamentLogoPicker;
